import uniqBy from 'lodash.uniqby';

import {
  TOOLBAR_PHOTO_GROUP_ENABLE,
  TOOLBAR_PHOTO_GROUP_TOGGLE_PHOTO,
  TOOLBAR_PHOTO_GROUP_RESET_PHOTOS,
  TOOLBAR_PHOTO_GROUP_DISMISS,
  TOOLBAR_PHOTO_GROUP_SELECT_PHOTOS,
  TOOLBAR_PHOTO_GROUP_DESELECT_PHOTOS,
  TOOLBAR_PHOTO_GROUP_DESELECT_ALL,
} from '../actions/photo-group-toolbar';

const initialState = {
  // Do not set to `null` since that's what the ungrouped photos
  // "photo group" is using as an ID.
  enabledPhotoGroupId: undefined,
  selectedPhotos: [],
};

const photoGroupToolbarReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TOOLBAR_PHOTO_GROUP_ENABLE:
      return {
        ...state,
        enabledPhotoGroupId: action.photoGroupId,
        selectedPhotos: initialState.selectedPhotos,
      };

    case TOOLBAR_PHOTO_GROUP_TOGGLE_PHOTO:
      return {
        ...state,
        selectedPhotos: state.selectedPhotos.includes(action.photoId)
          ? state.selectedPhotos.filter(id => id !== action.photoId)
          : [...state.selectedPhotos, action.photoId],
      };

    case TOOLBAR_PHOTO_GROUP_SELECT_PHOTOS:
      return {
        ...state,
        selectedPhotos: uniqBy([...state.selectedPhotos, ...action.photos]),
      };

    case TOOLBAR_PHOTO_GROUP_DESELECT_PHOTOS:
      return {
        ...state,
        selectedPhotos: state.selectedPhotos.filter(
          photoId => !action.photos.includes(photoId),
        ),
      };

    case TOOLBAR_PHOTO_GROUP_DESELECT_ALL:
      return {
        ...state,
        selectedPhotos: initialState.selectedPhotos,
      };

    case TOOLBAR_PHOTO_GROUP_RESET_PHOTOS:
      return {
        ...state,
        selectedPhotos: initialState.selectedPhotos,
      };

    case TOOLBAR_PHOTO_GROUP_DISMISS:
      return {
        ...state,
        enabledPhotoGroupId: undefined,
        selectedPhotos: initialState.selectedPhotos,
      };

    default:
      return state;
  }
};

export { initialState };
export default photoGroupToolbarReducer;
